module.exports = __webpack_public_path__ + "img/ico-yz3.b85ae7ce.png";